import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const DynamicTitle = () => {
  const location = useLocation();

  const getTitle = () => {
    if (location.pathname.startsWith("/for-reviewers")) {
      return "For Reviewers - Journal of Applied Bioanalysis";
    } else if (
      location.pathname.startsWith("/information/article-processing-charges")
    ) {
      return "Article Processing Charges - Journal of Applied Bioanalysis";
    } else if (location.pathname.startsWith("/information/for-authors-2")) {
      return "For Authors - Journal of Applied Bioanalysis";
    } else if (
      location.pathname.startsWith(
        "/information/editorial-criteria-and-processes"
      )
    ) {
      return "Editorial criteria and processes - Journal of Applied Bioanalysis";
    } else if (location.pathname.startsWith("/auth")) {
      return "Authentication - Journal of Applied Bioanalysis";
    }

    switch (location.pathname) {
      case "/about":
        return "About - Journal of Applied Bioanalysis";
      case "/privacy":
        return "Privacy - Journal of Applied Bioanalysis";
      case "/terms-condition":
        return "Terms and Condition - Journal of Applied Bioanalysis";
      case "/copyright":
        return "Copyright - Journal of Applied Bioanalysis";
      case "/journal-information":
        return "Journal Information - Journal of Applied Bioanalysis";
      case "/submit-article":
        return "Submit Article - Journal of Applied Bioanalysis";
      case "/issue-archive":
        return "Issue Archive - Journal of Applied Bioanalysis";
      case "/current-issue":
        return "Current Issue - Journal of Applied Bioanalysis";
      case "/editorial-board-journal-of-applied-bioanalysis":
        return "Editorial Board - Journal of Applied Bioanalysis";
      case "/author/article":
        return "Author Articles - Journal of Applied Bioanalysis";
      case "/author/article-submission":
        return "Author Article Submission - Journal of Applied Bioanalysis";
      default:
        return "Journal of Applied Bioanalysis";
    }
  };

  const metaDescription = `The Journal of Applied Bioanalysis is a publication that stands at the forefront of advancements in the field of bioanalysis. This peer-reviewed journal serves as a vital platform for researchers, scientists, and practitioners to share and disseminate their cutting-edge research, innovative methodologies, and practical applications across various domains of bioanalysis.`;

  return (
    <Helmet>
      <title>{getTitle()}</title>
      <meta name="metadescription" content={metaDescription} />
      <meta property="og:title" content={getTitle()} />
      <meta
        property="og:image"
        content="https://www.scopus.com/sourceid/21101122745/"
      />
    </Helmet>
  );
};

export default DynamicTitle;
